function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.25C4.61929 1.25 3.5 2.36929 3.5 3.75C3.5 5.13071 4.61929 6.25 6 6.25C7.38071 6.25 8.5 5.13071 8.5 3.75C8.5 2.36929 7.38071 1.25 6 1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.25C3.33696 7.25 2.70107 7.51339 2.23223 7.98223C1.76339 8.45107 1.5 9.08696 1.5 9.75V10.25C1.5 10.5261 1.72386 10.75 2 10.75C2.49971 10.75 9.50029 10.75 10 10.75C10.2761 10.75 10.5 10.5261 10.5 10.25V9.75C10.5 9.08696 10.2366 8.45107 9.76777 7.98223C9.29893 7.51339 8.66304 7.25 8 7.25H4Z"
  }));
};

export default SvgComponent;